import * as React from "react";
import { useEffect } from "react";

export const LoadingSpinner = () => {
    useEffect(() => {
        // Disable scrolling when the loading spinner is shown
        document.body.style.overflow = "hidden";

        // Re-enable scrolling when the component is unmounted
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <div
            style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                background: "rgba(255, 255, 255, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: "20",
            }}
        >
            <div className="page-spinner" />
        </div>
    );
};
